import { CircularProgress, DialogContent, Stack } from "@mui/material";
import { PageHeaderWrapper, Title } from "@src/appV2/redesign/system/ui-components";

import { PAGE_HEADER_SPACER_MIN_HEIGHT } from "./constants";

export function BadgeVerificationGradingContent() {
  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <Stack sx={{ minHeight: PAGE_HEADER_SPACER_MIN_HEIGHT }} />
      </PageHeaderWrapper>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack spacing={6} alignItems="center" textAlign="center">
          <CircularProgress size={64} />
          <Title variant="h4" component="h1">
            Hang tight while we take a look at your badge
          </Title>
        </Stack>
      </DialogContent>
    </>
  );
}
